// No tests, tested in use-formatted-conditions.test.tsx
import { SelectableCondition } from '@/hooks/use-formatted-conditions';
import {
    UsercryptCondition,
    UsercryptConditions,
    UsercryptSupportedCondition,
} from '@calm/evexia-web-sdk';

interface getAddedConditionsProps {
    selectedConditions: SelectableCondition[];
    circleConditions?: UsercryptConditions;
}

interface getRemovedConditionsProps extends getAddedConditionsProps {
    supportedConditions: SelectableCondition[];
}

export type FormattedCondition = UsercryptSupportedCondition & {
    addedConditionMetadata?: UsercryptCondition;
    searchTerms: string[];
};

export function sortConditions(
    a: UsercryptSupportedCondition,
    b: UsercryptSupportedCondition
) {
    return a.name.localeCompare(b.name);
}

export function formatCondition(
    condition: UsercryptSupportedCondition | SelectableCondition,
    addedConditionMetadata?: UsercryptCondition
): FormattedCondition {
    return {
        ...condition,
        addedConditionMetadata,
        searchTerms: [
            condition?.name,
            condition?.category ?? condition?.subtype,
            ...(condition?.keywords ?? []),
        ]
            .filter((term) => !!term)
            .map((term) => term.toLowerCase()),
    };
}

export function getAddedConditions({
    selectedConditions,
    circleConditions,
}: getAddedConditionsProps): SelectableCondition[] {
    return selectedConditions.reduce<SelectableCondition[]>(
        (newlyAddedChoices, choice) => {
            const matchingItem = circleConditions?.conditions?.find(
                (condition) => condition.configId === choice.id
            );
            if (matchingItem === undefined) {
                return [...newlyAddedChoices, choice];
            }
            return newlyAddedChoices;
        },
        []
    );
}

export function getRemovedConditions({
    supportedConditions,
    selectedConditions,
    circleConditions,
}: getRemovedConditionsProps): SelectableCondition[] | undefined {
    return circleConditions?.conditions?.reduce<SelectableCondition[]>(
        (removedChoices, condition) => {
            const matchingItem = selectedConditions.find(
                (choice) => choice.id === condition.configId
            );
            if (matchingItem === undefined) {
                const choice = supportedConditions.find(
                    (item) => item.id === condition.configId
                );
                if (choice) {
                    return [...removedChoices, choice];
                }
            }
            return removedChoices;
        },
        []
    );
}
